import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="d-error-page not-found">
      <i className="ri-error-warning-line ri-48px text-warning"></i>
      <h2>404</h2>
      <h3>{t('common.errorMessages.notFoundPage.notFound')}</h3>
      <p>{t('common.errorMessages.notFoundPage.message')}</p>
    </div>
  );
};

export default NotFound;
